// extracted by mini-css-extract-plugin
export default {"PCS":"MM7yJeYYg3"};